import * as React from 'react';
import { cn } from '@noor/lib/cn';

export type IconProps = React.ComponentProps<'svg'>;

/** 1. Dashboard / Analytics Pie Chart */
export function ChartPieIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        d="M8.5 7.83513C8.50001 9.76812 10.067 11.3351 12 11.3351H17.9854C17.7259 16.0731 13.8028 19.8351 9 19.8351C4.02944 19.8351 5.66963e-06 15.8057 0 10.8351C9.21312e-06 6.03236 3.76201 2.10825 8.5 1.8488V7.83513ZM10 1.83513C10 0.730563 10.9045 -0.185918 11.9873 0.0323982C15.9159 0.824512 19.0106 3.91927 19.8027 7.84783C20.0211 8.93061 19.1046 9.83513 18 9.83513H12C10.8954 9.83513 10 8.9397 10 7.83513V1.83513Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 2. Couriers Scooter / Bike */
export function ScooterBikeIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5C15 4.44772 15.4477 4 16 4C18.7614 4 21 6.23858 21 9V11C21 11.5523 20.5523 12 20 12H18C15.7909 12 14 13.7909 14 16C14 16.5523 13.5523 17 13 17H10C10 18.6568 8.65685 20 7 20C5.34315 20 4 18.6568 4 17H3C2.44772 17 2 16.5523 2 16V15C2 12.2386 4.23858 10 7 10H9C9.55228 10 10 10.4477 10 11V15H12.083C12.559 12.1623 15.027 10 18 10H19V9C19 7.34315 17.6569 6 16 6C15.4477 6 15 5.55228 15 5Z"
        fill="currentColor"
      />
      <path
        d="M5 6C4.44772 6 4 6.44772 4 7C4 7.55228 4.44772 8 5 8H9C9.55228 8 10 7.55228 10 7C10 6.44772 9.55228 6 9 6H5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 14C17.3431 14 16 15.3431 16 17C16 18.6569 17.3431 20 19 20C20.6569 20 22 18.6569 22 17C22 15.3431 20.6569 14 19 14Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 3. Warning / Error Triangle */
export function WarningErrorIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 18"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.96798 1.16592C8.85365 -0.388639 11.1464 -0.388642 12.032 1.16592L19.7041 14.6324C20.5649 16.1433 19.4445 18 17.6721 18H2.32789C0.555459 18 -0.564896 16.1433 0.29587 14.6324L7.96798 1.16592ZM10.9999 14C10.9999 14.5523 10.5522 15 9.99994 15C9.44765 15 8.99994 14.5523 8.99994 14C8.99994 13.4477 9.44765 13 9.99994 13C10.5522 13 10.9999 13.4477 10.9999 14ZM10.7499 6C10.7499 5.58579 10.4142 5.25 9.99994 5.25C9.58573 5.25 9.24994 5.58579 9.24994 6V11C9.24994 11.4142 9.58573 11.75 9.99994 11.75C10.4142 11.75 10.7499 11.4142 10.7499 11V6Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 4. Donate Coin / Finance */
export function DonateCoinIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 16"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        d="M1.58203 4C1.85771 4.00005 2.13023 4.05751 2.38281 4.16797L8.2627 6.73926C9.22431 7.16009 9.66627 8.27831 9.25293 9.24316C9.19016 9.38963 9.1116 9.52494 9.01953 9.64648L11.7334 11.3662C12.5664 11.7827 13.4847 11.9999 14.416 12H16C17.1046 12 18 12.8954 18 14C18 15.1046 17.1046 16 16 16H7.88867C6.64671 16 5.42139 15.7107 4.31055 15.1553L0 13V4H1.58203ZM16 0C18.2091 0 20 1.79086 20 4C20 6.20914 18.2091 8 16 8C13.7909 8 12 6.20914 12 4C12 1.79086 13.7909 0 16 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 5. Support / Chat */
export function ChatBubbleIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 18"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0H11C15.9706 0 20 4.02944 20 9C20 13.9706 15.9706 18 11 18H4C1.79086 18 0 16.2091 0 14V9C0 4.02944 4.02944 0 9 0ZM10 10C10.5523 10 11 9.55229 11 9C11 8.44771 10.5523 8 10 8C9.44771 8 9 8.44771 9 9C9 9.55229 9.44771 10 10 10ZM15 9C15 9.55229 14.5523 10 14 10C13.4477 10 13 9.55229 13 9C13 8.44771 13.4477 8 14 8C14.5523 8 15 8.44771 15 9ZM6 10C6.55228 10 7 9.55229 7 9C7 8.44771 6.55228 8 6 8C5.44772 8 5 8.44771 5 9C5 9.55229 5.44772 10 6 10Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 6. Notepad / Orders */
export function NotepadIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 20"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        d="M14.4922 2.03027C16.4689 2.27306 18 3.95767 18 6V16C18 18.2091 16.2091 20 14 20H4C1.79086 20 6.18484e-06 18.2091 0 16V6C0 3.95767 1.53111 2.27306 3.50781 2.03027C3.50296 2.1029 3.5 2.17615 3.5 2.25C3.50001 4.04492 4.95508 5.5 6.75 5.5H11.25C13.0449 5.5 14.5 4.04492 14.5 2.25C14.5 2.17615 14.497 2.1029 14.4922 2.03027ZM5 15.25C4.58579 15.25 4.25 15.5858 4.25 16C4.25 16.4142 4.58579 16.75 5 16.75H9C9.41421 16.75 9.75 16.4142 9.75 16C9.75 15.5858 9.41421 15.25 9 15.25H5ZM5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H13C13.4142 12.75 13.75 12.4142 13.75 12C13.75 11.5858 13.4142 11.25 13 11.25H5ZM5 7.25C4.58579 7.25 4.25 7.58579 4.25 8C4.25 8.41421 4.58579 8.75 5 8.75H13C13.4142 8.75 13.75 8.41421 13.75 8C13.75 7.58579 13.4142 7.25 13 7.25H5ZM11 0C12.1046 0 13 0.895431 13 2C13 3.10457 12.1046 4 11 4H7C5.89543 4 5 3.10457 5 2C5 0.895431 5.89543 0 7 0H11Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 7. Bookmark / Catalog */
export function BookmarkIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 7.75V18C4 19.6481 5.88153 20.5889 7.2 19.6L10.8 16.9C11.5111 16.3667 12.4889 16.3667 13.2 16.9L16.8 19.6C18.1185 20.5889 20 19.6481 20 18V7.75H4ZM4 6.25H20V4C20 2.89543 19.1046 2 18 2H6C4.89543 2 4 2.89543 4 4V6.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** 8. User / Profile */
export function UserCircleIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 14 18"
      fill="none"
      className={cn('size-6 shrink-0', className)}
      {...props}
    >
      <path
        d="M7 10C10.866 10 14 11.7909 14 14C14 16.2091 10.866 18 7 18C3.13401 18 0 16.2091 0 14C0 11.7909 3.13401 10 7 10ZM7 0C9.20914 0 11 1.79086 11 4C11 6.20914 9.20914 8 7 8C4.79086 8 3 6.20914 3 4C3 1.79086 4.79086 0 7 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Calendar / Schedule Icon */
export function CalendarScheduleIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        d="M17 7.2H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 2.3V4.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 2.3V4.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 17H5.5C4.12 17 3 15.88 3 14.5V5.5C3 4.12 4.12 3 5.5 3H14.5C15.88 3 17 4.12 17 5.5V14.5C17 15.88 15.88 17 14.5 17Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11L12.2 10V14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11L8.2 10V14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Command Key Shortcut Icon ⌘ */
export function CommandKeyIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 18"
      fill="none"
      className={cn('size-4 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 6.75H4.5C3.25725 6.75 2.25 5.74275 2.25 4.5V4.5C2.25 3.25725 3.25725 2.25 4.5 2.25V2.25C5.74275 2.25 6.75 3.25725 6.75 4.5V6.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 6.75H11.25V11.25H6.75V6.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 15.75V15.75C3.25725 15.75 2.25 14.7428 2.25 13.5V13.5C2.25 12.2573 3.25725 11.25 4.5 11.25H6.75V13.5C6.75 14.7428 5.74275 15.75 4.5 15.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 11.25H13.5C14.7428 11.25 15.75 12.2573 15.75 13.5V13.5C15.75 14.7428 14.7428 15.75 13.5 15.75V15.75C12.2573 15.75 11.25 14.7428 11.25 13.5V11.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 2.25V2.25C14.7428 2.25 15.75 3.25725 15.75 4.5V4.5C15.75 5.74275 14.7428 6.75 13.5 6.75H11.25V4.5C11.25 3.25725 12.2573 2.25 13.5 2.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Notification Bell Icon with indicator slot */
export function NotificationBellIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 20"
      fill="none"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        d="M6.75 2.75C6.75 2.21957 6.96078 1.71086 7.33586 1.33579C7.71093 0.960714 8.21964 0.75 8.75 0.75C9.2805 0.75 9.78921 0.960714 10.1643 1.33579C10.5394 1.71086 10.75 2.21957 10.75 2.75C11.8985 3.29303 12.8775 4.13833 13.5821 5.1953C14.2868 6.25227 14.6905 7.48107 14.75 8.75V11.75C14.8253 12.3717 15.0455 12.9671 15.3929 13.4881C15.7403 14.0092 16.2051 14.4414 16.75 14.75H0.75C1.29501 14.4414 1.75988 14.0092 2.10726 13.4881C2.45463 12.9671 2.67481 12.3717 2.75 11.75V8.75C2.80963 7.48107 3.21337 6.25227 3.91802 5.1953C4.62267 4.13833 5.60166 3.29303 6.75 2.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 14.75V15.75C5.75 16.5456 6.06614 17.3087 6.62875 17.8713C7.19136 18.4339 7.95442 18.75 8.75 18.75C9.54572 18.75 10.3088 18.4339 10.8714 17.8713C11.434 17.3087 11.75 16.5456 11.75 15.75V14.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Chevron Down Icon */
export function ChevronDownIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      fill="none"
      className={cn('size-4 shrink-0', className)}
      {...props}
    >
      <path
        d="M4 6L8 10L12 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Edit 03 Pencil Icon */
export function Edit03Icon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 18"
      fill="none"
      className={cn('size-4.5 shrink-0', className)}
      {...props}
    >
      <path
        d="M10.35 14.6637H14.85M3.15002 14.6637L6.42451 14.0039C6.59834 13.9689 6.75796 13.8833 6.88331 13.7579L14.2136 6.42358C14.565 6.07194 14.5648 5.50195 14.213 5.1506L12.6602 3.59955C12.3086 3.24835 11.7389 3.24859 11.3876 3.60008L4.0566 10.9351C3.93149 11.0603 3.84606 11.2196 3.811 11.3931L3.15002 14.6637Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Outline X Circle Icon */
export function IconOutlineXCircle({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 18"
      fill="none"
      className={cn('size-4.5 shrink-0', className)}
      {...props}
    >
      <path
        d="M7.5 10.5L9 9M9 9L10.5 7.5M9 9L7.5 7.5M9 9L10.5 10.5M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Arrows / Diagrams Chevron Arrow */
export function ArrowsDiagramsArrow({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 18 18"
      fill="none"
      className={cn('size-4.5 shrink-0', className)}
      {...props}
    >
      <path
        d="M7.5 12L10.5 9L7.5 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma Node 724:4283 — Phone, Call */
export function PhoneCall01Icon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.856 13.144C9.686 11.974 8.804 10.664 8.218 9.335C8.094 9.054 8.167 8.725 8.384 8.508L9.203 7.69C9.874 7.019 9.874 6.07 9.288 5.484L8.114 4.31C7.333 3.529 6.067 3.529 5.286 4.31L4.634 4.962C3.893 5.703 3.584 6.772 3.784 7.832C4.278 10.445 5.796 13.306 8.245 15.755C10.694 18.204 13.555 19.722 16.168 20.216C17.228 20.416 18.297 20.107 19.038 19.366L19.689 18.715C20.47 17.934 20.47 16.668 19.689 15.887L18.516 14.714C17.93 14.128 16.98 14.128 16.395 14.714L15.492 15.618C15.275 15.835 14.946 15.908 14.665 15.784C13.336 15.197 12.026 14.314 10.856 13.144Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma Node 24:6044 — Interface, Essential / Lock */
export function LockKeyIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        d="M8 10V7C8 4.791 9.791 3 12 3C14.209 3 16 4.791 16 7V10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14V17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21H7C5.895 21 5 20.105 5 19V12C5 10.895 5.895 10 7 10H17C18.105 10 19 10.895 19 12V19C19 20.105 18.105 21 17 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma Node 724:4482 — Chevron Down */
export function ChevronDownFigmaIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-5 shrink-0', className)}
      {...props}
    >
      <path
        d="M5 7.5L10 12.5L15 7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Figma Node 724:4478 — Sun Icon (16x16) */
export function ThemeSunIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      fill="none"
      className={cn('size-4 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68175 0.142976C7.50643 0.205087 7.29421 0.422507 7.23275 0.60301C7.15991 0.8169 7.16117 2.13247 7.2344 2.34755C7.33079 2.63061 7.64639 2.85377 7.95031 2.85377C8.25423 2.85377 8.56983 2.63061 8.66622 2.34755C8.73945 2.13247 8.74071 0.8169 8.66787 0.60301C8.53573 0.214968 8.07951 0.00212101 7.68175 0.142976ZM2.66013 2.2248C2.50029 2.28145 2.26185 2.53119 2.21855 2.68732C2.20015 2.75355 2.18506 2.87752 2.18497 2.96284C2.18466 3.23083 2.28175 3.37104 2.86751 3.94842C3.42756 4.50049 3.53603 4.57226 3.81017 4.57226C4.20956 4.57226 4.57686 4.20472 4.57686 3.80508C4.57686 3.53077 4.50513 3.42222 3.95342 2.86181C3.36635 2.26547 3.23764 2.17776 2.95313 2.18C2.85944 2.18074 2.7276 2.2009 2.66013 2.2248ZM12.6226 2.25574C12.5137 2.31002 12.3138 2.48948 11.9472 2.86181C11.3955 3.42222 11.3238 3.53077 11.3238 3.80508C11.3238 4.20472 11.6911 4.57226 12.0905 4.57226C12.3646 4.57226 12.4731 4.50049 13.0331 3.94842C13.6189 3.37104 13.716 3.23083 13.7157 2.96284C13.7154 2.70736 13.6628 2.57734 13.4901 2.40451C13.2477 2.16193 12.9225 2.10617 12.6226 2.25574ZM7.47496 4.0383C7.44123 4.04644 7.30322 4.07421 7.16828 4.10002C5.64986 4.39041 4.43168 5.61192 4.09599 7.18069C4.01791 7.54553 4.01804 8.35119 4.09621 8.71505C4.43601 10.2965 5.60506 11.4663 7.18362 11.8046C7.54761 11.8826 8.35301 11.8826 8.717 11.8046C10.2956 11.4663 11.4646 10.2965 11.8044 8.71505C11.8826 8.35119 11.8827 7.54553 11.8046 7.18069C11.4701 5.61732 10.307 4.44368 8.74767 4.09603C8.52499 4.04641 7.61309 4.00504 7.47496 4.0383ZM0.597514 7.23175C0.328927 7.32688 0.0993789 7.65689 0.0993789 7.94787C0.0993789 8.24676 0.329448 8.57018 0.610149 8.66589C0.823903 8.73878 2.13863 8.73752 2.35358 8.66424C2.63646 8.56778 2.85947 8.25198 2.85947 7.94787C2.85947 7.64376 2.63646 7.32796 2.35358 7.23151C2.14608 7.16077 0.797468 7.16095 0.597514 7.23175ZM13.55 7.22896C13.3753 7.293 13.2381 7.40854 13.1415 7.57299C13.069 7.69642 13.0565 7.75159 13.0565 7.94787C13.0565 8.14415 13.069 8.19932 13.1415 8.32275C13.2408 8.49171 13.3759 8.60317 13.5608 8.66841C13.7572 8.73776 15.0854 8.73583 15.2905 8.66589C15.5712 8.57018 15.8012 8.24676 15.8012 7.94787C15.8012 7.64898 15.5712 7.32556 15.2905 7.22985C15.0922 7.16224 13.7338 7.16157 13.55 7.22896ZM3.53416 11.377C3.34586 11.4435 2.37652 12.3928 2.26182 12.6231C2.11235 12.9233 2.16807 13.2487 2.4105 13.4912C2.58322 13.6641 2.71316 13.7166 2.96847 13.7169C3.23629 13.7172 3.37641 13.6201 3.95342 13.0339C4.3893 12.5912 4.48256 12.4803 4.52553 12.3537C4.62719 12.0542 4.56398 11.7757 4.34443 11.5561C4.1255 11.337 3.83164 11.272 3.53416 11.377ZM11.8219 11.3745C11.5533 11.4697 11.3238 11.7997 11.3238 12.0907C11.3238 12.365 11.3955 12.4735 11.9472 13.0339C12.5242 13.6201 12.6643 13.7172 12.9322 13.7169C13.1875 13.7166 13.3174 13.6641 13.4901 13.4912C13.6628 13.3184 13.7154 13.1884 13.7157 12.9329C13.716 12.6649 13.6189 12.5247 13.0331 11.9473C12.5906 11.5112 12.4798 11.4178 12.3533 11.3748C12.1706 11.3127 11.9968 11.3126 11.8219 11.3745ZM7.69353 13.0851C7.51863 13.1503 7.36269 13.2897 7.27574 13.4586C7.20073 13.6043 7.19874 13.6255 7.18978 14.3711C7.17905 15.2625 7.19561 15.3507 7.4154 15.5706C7.72248 15.8779 8.1779 15.8782 8.48457 15.5712C8.69863 15.3571 8.717 15.2662 8.717 14.4213C8.717 13.6359 8.70057 13.5305 8.54668 13.3286C8.36801 13.0942 7.97236 12.9813 7.69353 13.0851Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Figma Node 724:4480 — Moon Icon */
export function ThemeMoonIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      fill="none"
      className={cn('size-4 shrink-0', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.76757 0.299408C4.22584 0.813525 3.03183 1.64718 1.93404 2.97591C1.74788 3.2012 1.33423 3.86109 1.14644 4.23233C0.72348 5.06842 0.453389 5.95442 0.338047 6.88418C0.279149 7.35878 0.286757 8.43171 0.352173 8.87995C0.609229 10.6411 1.34132 12.1282 2.56264 13.3698C3.78969 14.6173 5.32321 15.3898 7.08619 15.6485C7.52188 15.7124 8.59743 15.7207 9.0414 15.6636C11.311 15.3716 13.2926 14.1811 14.5764 12.3383C14.9189 11.8467 15.2385 11.245 15.4537 10.6868C15.593 10.3256 15.8012 9.6136 15.8012 9.49876C15.8012 9.36963 15.6918 9.17575 15.5803 9.10738C15.3374 8.95847 15.1522 8.9976 14.7921 9.27384C13.8028 10.0325 12.7822 10.4244 11.5689 10.5115C11.0952 10.5456 10.8685 10.5361 10.3449 10.4605C8.05822 10.1301 6.18289 8.45334 5.56732 6.1888C5.31172 5.24841 5.3072 4.14796 5.55507 3.18414C5.75817 2.39436 6.00474 1.88944 6.6023 1.03964C6.76327 0.810753 6.78194 0.649293 6.67054 0.450081C6.51406 0.170216 6.27471 0.130301 5.76757 0.299408Z"
        fill="currentColor"
      />
    </svg>
  );
}

/** Figma Node 724:4339 — Emojione Flag for Russia */
export function FlagRussiaIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-5 shrink-0 rounded-full', className)}
      {...props}
    >
      <path
        d="M9.96875 0.625C5.90625 0.625 2.4375 3.25 1.15625 6.875H18.8437C17.5312 3.25 14.0625 0.625 9.96875 0.625Z"
        fill="white"
      />
      <path
        d="M9.96875 19.375C14.0625 19.375 17.5313 16.75 18.8125 13.125H1.15625C2.4375 16.7812 5.90625 19.375 9.96875 19.375Z"
        fill="#ED4C5C"
      />
      <path
        d="M1.15625 6.875C0.8125 7.84375 0.625 8.90625 0.625 10C0.625 11.0938 0.8125 12.1563 1.15625 13.125H18.8437C19.1875 12.1563 19.375 11.0938 19.375 10C19.375 8.90625 19.1875 7.84375 18.8437 6.875H1.15625Z"
        fill="#428BC1"
      />
    </svg>
  );
}

/** Flag for Uzbekistan */
export function FlagUzbekistanIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-5 shrink-0 rounded-full', className)}
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="#1EB53A" />
      <path d="M0 0H20V6.67H0V0Z" fill="#0099B5" />
      <path d="M0 6.67H20V13.33H0V6.67Z" fill="white" />
      <path d="M0 6.33H20V7.03H0V6.33ZM0 12.97H20V13.67H0V12.97Z" fill="#CE1126" />
      <circle cx="4.5" cy="3.33" r="2" fill="white" />
      <circle cx="5.2" cy="3.33" r="1.7" fill="#0099B5" />
    </svg>
  );
}

/** Flag for UK / English */
export function FlagUkIcon({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 20 20"
      fill="none"
      className={cn('size-5 shrink-0 rounded-full', className)}
      {...props}
    >
      <circle cx="10" cy="10" r="10" fill="#012169" />
      <path d="M0 0L20 20M20 0L0 20" stroke="white" strokeWidth="2.5" />
      <path d="M0 0L20 20M20 0L0 20" stroke="#C8102E" strokeWidth="1.5" />
      <path d="M10 0V20M0 10H20" stroke="white" strokeWidth="4" />
      <path d="M10 0V20M0 10H20" stroke="#C8102E" strokeWidth="2.5" />
    </svg>
  );
}

/** Figma Node 724:4440 — Noor Wordmark Logo */
export function NoorWordmarkLogo({ className, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 115.944 31.9184"
      fill="none"
      className={cn('h-8 w-[116px] shrink-0', className)}
      {...props}
    >
      <g id="Group">
        <path
          id="Vector"
          d="M28.4184 31.0965H20.5986V14.1333C20.5986 11.7114 20.1702 9.93883 19.3135 8.8251C18.4599 7.70824 17.2718 7.15294 15.7522 7.15294C14.7017 7.15294 13.6417 7.41961 12.5724 7.95294C11.4999 8.48942 10.5369 9.2204 9.68334 10.1522C8.82976 11.0839 8.20442 12.1631 7.81671 13.3804V31.0965H0V0.705885H7.06005V6.37177C7.8386 5.05726 8.83288 3.94981 10.0367 3.04314C11.2404 2.13647 12.6349 1.44 14.2108 0.960003C15.7866 0.480003 17.45 0.235297 19.201 0.235297C21.1051 0.235297 22.6747 0.57412 23.9004 1.24863C25.126 1.92314 26.0609 2.82981 26.7019 3.97177C27.3429 5.11373 27.79 6.39373 28.0432 7.82432C28.2965 9.25177 28.4216 10.7012 28.4216 12.1663C28.4184 12.1663 28.4184 31.0965 28.4184 31.0965Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M41.1785 31.9184C38.2644 31.9184 35.9913 31.3255 34.3592 30.1459C32.7239 28.9663 31.6546 27.3882 31.1544 25.4055C30.651 23.4259 30.6259 21.2392 31.0824 18.8518C31.5608 16.342 32.4676 13.9545 33.7995 11.6831C35.1346 9.41177 36.7918 7.39451 38.7772 5.63451C40.7627 3.87451 42.9701 2.49412 45.3995 1.49647C47.829 0.501964 50.3897 0.00314036 53.0693 0.00627762C55.9802 0.00627762 58.2565 0.599219 59.8886 1.77883C61.5238 2.95844 62.5932 4.52706 63.1028 6.48785C63.6125 8.44863 63.6312 10.6416 63.1685 13.0698C62.7057 15.498 61.7833 17.9671 60.4514 20.2384C59.1163 22.5098 57.4591 24.5302 55.4737 26.2871C53.4883 28.0471 51.2808 29.4275 48.8514 30.4251C46.422 31.4196 43.8612 31.9184 41.1816 31.9153H41.1785V31.9184ZM43.6173 25.142C44.8055 25.142 46.0061 24.8753 47.2224 24.3294C48.4355 23.7867 49.5736 23.0118 50.6273 21.9984C51.681 20.9851 52.6003 19.8024 53.3757 18.4439C54.1511 17.0855 54.692 15.6078 54.9984 14.0141C55.2736 12.5741 55.2955 11.3129 55.061 10.2243C54.8265 9.13569 54.3356 8.28863 53.5883 7.68628C52.841 7.08393 51.853 6.77961 50.6273 6.77961C49.4017 6.77961 48.2479 7.04628 47.0504 7.59216C45.8529 8.13491 44.721 8.90981 43.6455 9.92314C42.5699 10.9302 41.6444 12.1286 40.8658 13.509C40.0873 14.8894 39.5432 16.3733 39.24 17.9671C38.9742 19.3694 38.9554 20.6118 39.1899 21.6973C39.4244 22.7859 39.9153 23.6329 40.6626 24.2353C41.4099 24.8377 42.3979 25.142 43.6236 25.142H43.6173Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M73.2677 31.9184C70.3536 31.9184 68.0805 31.3255 66.4484 30.1459C64.8162 28.9663 63.7438 27.3882 63.2435 25.4055C62.7401 23.4259 62.7151 21.2392 63.1716 18.8518C63.65 16.342 64.5567 13.9545 65.8887 11.6831C67.2238 9.41177 68.8809 7.39451 70.8664 5.63451C72.8518 3.87451 75.0593 2.49412 77.4887 1.49647C79.9181 0.501964 82.4789 0.00314036 85.1585 0.00627762C88.0694 0.00627762 90.3456 0.599219 91.9777 1.77883C93.613 2.95844 94.6823 4.52706 95.192 6.48785C95.7016 8.44863 95.7204 10.6416 95.2576 13.0698C94.7949 15.498 93.8725 17.9671 92.5405 20.2384C91.2055 22.5098 89.5483 24.5302 87.5629 26.2871C85.5774 28.0471 83.37 29.4275 80.9405 30.4251C78.5111 31.4196 75.9504 31.9184 73.2708 31.9153H73.2677V31.9184ZM75.7065 25.142C76.8946 25.142 78.0953 24.8753 79.3115 24.3294C80.5247 23.7867 81.6628 23.0118 82.7165 21.9984C83.7702 20.9851 84.6894 19.8024 85.4649 18.4439C86.2403 17.0855 86.7812 15.6078 87.0876 14.0141C87.3628 12.5741 87.3846 11.3129 87.1501 10.2243C86.9156 9.13569 86.4248 8.28863 85.6775 7.68628C84.9302 7.08393 83.9422 6.77961 82.7165 6.77961C81.4908 6.77961 80.3371 7.04628 79.1396 7.59216C77.9421 8.13491 76.8102 8.90981 75.7346 9.92314C74.659 10.9302 73.7335 12.1286 72.955 13.509C72.1765 14.8894 71.6324 16.3733 71.3291 17.9671C71.0634 19.3694 71.0446 20.6118 71.2791 21.6973C71.5136 22.7859 72.0045 23.6329 72.7518 24.2353C73.499 24.8377 74.4871 25.142 75.7127 25.142H75.7065Z"
          fill="currentColor"
        />
        <path
          id="Vector_4"
          d="M115.941 7.20628C113.568 7.20628 111.448 7.66745 109.581 8.58353C107.714 9.49961 106.37 10.8173 105.554 12.5365V31.0996H97.734V0.705885H104.913V6.97098C106.001 4.86275 107.386 3.20314 109.056 1.99216C110.728 0.784317 112.498 0.119218 114.368 2.61793e-06H115.359C115.594 2.61793e-06 115.787 0.0219642 115.944 0.0596112L115.941 7.20628Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
